<template>
  <div class="monitoring-to-complete">
    <p class="monitoring-to-complete__subtitle">
      {{ $t('monitoringDashboard.toComplete.subtitle') }}
    </p>
    <ToCompleteSection />
  </div>
</template>

<script>
  import ToCompleteSection from './ToCompleteSection.vue';

  export default {
    name: 'MonitoringDashboardToComplete',
    components: { ToCompleteSection },
  };
</script>

<style lang="scss">
  .monitoring-to-complete {
    &__subtitle {
      color: $--color-text-secondary;
      margin: 0 0 1rem;
    }
  }
</style>
